import React, { useEffect } from "react";
import { Table, Switch, Space, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useWarehouseModel } from "../warehouseModel";

import { warehouseService, IWarehouseFileds, IWarehouseSearch, IWarehouseDetail, IShelfFileds, IShelfInsert, IShelfSearch, IShelfBatchInsert } from "../warehouseService";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useDictModel } from "../../dict/dictModel";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, onDisabled
    } = useWarehouseModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { getTreeNodeOne } = useDictModel();

    const columns: ColumnsType<IWarehouseDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 60,
            align: "center",
            fixed: "left",
            render: (t, r, i) => <>{i + 1}</>
        },
        {
            // title: '仓库编号',
            title: Locale["Warehouse Code"],
            width: 150,
            align: "center",
            dataIndex: 'code',
            fixed: "left",
            // render: text => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        },
        {
            // title: '仓库名称',
            title: Locale["Warehouse Name"],
            width: 150,
            align: "center",
            dataIndex: 'name',
            fixed: "left",
        },
        {
            // title: '仓库类别',
            title: Locale["Warehouse Type"],
            width: 150,
            align: "center",
            dataIndex: 'typeCode',
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0]?.name : getTreeNodeOne(text)[0]?.nameEn as string
                } else {
                    return ""
                }
            }
        },
        {
            // title: '仓库货位 总数',
            title: Locale["Total Qty of Warehouse Shelf"],
            width: 150,
            align: "center",
            dataIndex: 'num',
        },
        {
            // title: '联系人',
            title: Locale["Contact"],
            width: 150,
            align: "center",
            dataIndex: 'contact',
        },
        {
            // title: '联系电话',
            title: Locale["Contact Number"],
            width: 150,
            align: "center",
            dataIndex: 'phone',
        },
        {
            // title: '联系地址',
            title: Locale["Address"],
            width: 150,
            align: "center",
            dataIndex: 'address',
        },
        {
            // title: '备注',
            title: Locale["Note"],
            width: 150,
            align: "center",
            dataIndex: 'note',
        },
        {
            // title: '操作',
            title: Locale["Operation"],
            width: 150,
            align: "center",
            dataIndex: 'enable',
            render: (text, record) => (
                <Space size="middle">
                    <Switch checked={record.enable === 1} onChange={(checked) => {
                        onDisabled(record.id as string, checked);
                    }} />
                </Space>
            ),
        }
    ];
    useEffect(() => {
        loadData();
    }, [])

    return (
        <Table
            rowKey={record => record.id as string}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: event => setSelectedRowKeys(selectedRowKeys === record.id as string ? "" : record.id as string)
            })}
            rowClassName={(record, index) => record.id === selectedRowKeys ? "table-select-row" : ""}
            scroll={{ x: 'max-content' }}
        />
    )
}
